export default __webpack_public_path__ + "static/media/background.6a8e4a3c.jpg";